import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { AuthService } from '@shared/services/auth.service'
import { ToastService } from '../../services/toast.service'

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup
  oobCode: string | null = null
  pageTitle = 'Jelszó visszaállítása'

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router
  ) {
    this.resetPasswordForm = new FormGroup({
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    })
  }

  ngOnInit(): void {
    this.oobCode = this.route.snapshot.paramMap.get('oobCode')
    if (!this.oobCode) {
      this.toastService.showError('Érvénytelen jelszóvisszaállító link.')
      this.router.navigate(['/login'])
    }
  }

  onSubmit(): void {
    if (this.resetPasswordForm.invalid) {
      return
    }

    const password = this.resetPasswordForm.value.password
    const confirmPassword = this.resetPasswordForm.value.confirmPassword

    if (password !== confirmPassword) {
      this.toastService.showError('A jelszavak nem egyeznek.')
      return
    }

    if (!this.oobCode) {
      this.toastService.showError('Érvénytelen jelszóvisszaállító link.')
      return
    }

    this.authService.verifyPasswordResetCode(this.oobCode)
      .then(email => {
        return this.authService.confirmPasswordReset(this.oobCode as string, password)
          .then(() => {
            return this.authService.signInWithEmailAndPassword(email, password)
          })
      })
      .then(() => {
        this.toastService.showSuccess('A jelszavad megváltozott. Sikeresen bejelentkeztél.')
        this.router.navigate(['/'])
      })
      .catch(error => {
        console.error('Reset password error:', error)
        this.toastService.showError('Hiba történt a jelszó visszaállítása során.')
      })
  }
}